/**
 * Component for displaying book suggestions based on rules
 */

import './BookSuggestions.css';
import { generateRuleLabel } from '../../utils/ruleValidation';

function BookSuggestions({
    rule,
    suggestions,
    onAddBook,
    onLoadMore,
    onClose,
    loading,
    hasMore,
    onBookClick
}) {
    if (!rule) return null;

    return (
        <div className="suggestions-overlay" onClick={onClose}>
            <div className="suggestions-modal" onClick={(e) => e.stopPropagation()}>
                <div className="suggestions-header">
                    <div>
                        <h3 className="suggestions-title">Návrhy knih</h3>
                        <p className="suggestions-rule-label">
                            Pro pravidlo: {generateRuleLabel(rule)}
                        </p>
                    </div>
                    <button className="suggestions-close-btn" onClick={onClose} title="Zavřít">
                        ✕
                    </button>
                </div>

                <div className="suggestions-content">
                    {loading && suggestions.length === 0 ? (
                        <div className="suggestions-loading">
                            <p>Načítám návrhy...</p>
                        </div>
                    ) : suggestions.length === 0 && !hasMore ? (
                        <div className="suggestions-empty">
                            <p>Nebyly nalezeny žádné návrhy pro toto pravidlo.</p>
                        </div>
                    ) : suggestions.length === 0 && hasMore ? (
                        <div className="suggestions-load-more">
                            <button
                                className="btn-load-more"
                                onClick={onLoadMore}
                                disabled={loading}
                            >
                                {loading ? 'Načítám...' : 'Načíst návrhy'}
                            </button>
                        </div>
                    ) : (
                        <>
                            <div className="suggestions-list">
                                {suggestions.map(book => (
                                    <div key={book.id} className="suggestion-item">
                                        <div
                                            className="suggestion-info"
                                            onClick={() => onBookClick && onBookClick(book.id)}
                                            style={{ cursor: 'pointer', flex: 1 }}
                                        >
                                            <h4 className="suggestion-title">{book.bookTitle}</h4>
                                            <p className="suggestion-author">{book.author?.name}</p>
                                            {book.shortSummary && (
                                                <p className="suggestion-summary">{book.shortSummary}</p>
                                            )}
                                        </div>
                                        <button
                                            className="btn-add-suggestion"
                                            onClick={() => onAddBook(book)}
                                        >
                                            + Přidat
                                        </button>
                                    </div>
                                ))}
                            </div>

                            {hasMore && (
                                <div className="suggestions-load-more">
                                    <button
                                        className="btn-load-more"
                                        onClick={onLoadMore}
                                        disabled={loading}
                                    >
                                        {loading ? 'Načítám...' : 'Načíst další návrhy'}
                                    </button>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

export default BookSuggestions;
